import one from '../assets/svg/projects/showtime.png'
import two from '../assets/svg/projects/yowl.png'
import three from '../assets/svg/projects/postit.png'
import four from '../assets/svg/projects/tomatoes.png'


export const projectsData = [
    {
        id: 1,
        projectName: 'Showtime',
        projectDesc: 'ce projet est une plarteforme évènementielle',
        tags: ['Ejs', 'NestJs'],
        code: 'https://github.com/EpitechCodingAcademyPromo2026/C-COD-250-COT-2-1-showtime-6.git',
        demo: 'https://showtime-47cr.onrender.com/',
        image: one
    },
    {
        id: 2,
        projectName: 'Yowl',
        projectDesc: 'ce projet est une plarteforme de centralisation des commentaires sur internet',
        tags: ['VueJs', 'Tailwind CSS', 'Laravel'],
        code: 'https://github.com/EpitechCodingAcademyPromo2025/C-DEV-160-COT-1-1-yowl-ozias.djoi.git',
        demo: 'https://yowlhewo.netlify.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Postit',
        projectDesc: 'ce projet est une plarteforme de publication de produits',
        tags: ['VueJs', 'Laravel'],
        code: 'https://github.com/EpitechCodingAcademyPromo2025/C-DEV-121-COT-1-1-postit-esperance.ahouissou.git',
        demo: 'http://freeads.pixeluxt.com/',
        image: three
    },
    {
        id: 4,
        projectName: 'Tomatoes',
        projectDesc: 'ce projet est une plarteforme de publication et d\'avis sur des films',
        tags: ['Tailwindcss', 'React', 'NextJs'],
        code: 'https://github.com/EpitechCodingAcademyPromo2026/C-COD-270-COT-2-1-c2cod270p0-8.git',
        demo: 'https://tomatoes-farmers.vercel.app/',
        image: four
    },
   
]


// Do not remove any fields.
// Leave it blank instead as shown below
//..
/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/